"use client";

import LegalArticle from "@/components/sections/LegalArticle";
import LegalPageShell from "@/components/sections/LegalPageShell";
import LegalPolicyEmbed from "@/components/sections/LegalPolicyEmbed";
import { getLegalContent } from "@/content/legal";
import {
  getLegalPolicyTitle,
  getLegalSyncDateLabel,
  type LegalPolicyKey,
} from "@/content/legal-policies";
import { useLocale } from "@/lib/i18n/provider";

type Props = {
  page: LegalPolicyKey;
};

export default function LegalPolicyPage({ page }: Props) {
  const { locale } = useLocale();
  const legal = getLegalContent(locale);
  const syncedDate = getLegalSyncDateLabel(locale);
  const title = getLegalPolicyTitle(page, locale);

  const legacy =
    page === "privacy" || page === "terms" || page === "cookies"
      ? legal[page]
      : null;

  return (
    <LegalPageShell>
      <LegalArticle
        eyebrow={legacy?.eyebrow ?? "Legal"}
        title={legacy?.title ?? title}
        lastUpdated={syncedDate || legacy?.lastUpdated || ""}
      >
        <LegalPolicyEmbed page={page} locale={locale} />
      </LegalArticle>
    </LegalPageShell>
  );
}
